/* Predictive search for the header search panel. Progressive enhancement: without this script (or on any
   failure) the form submits to /search exactly as before. Results come from Shopify's Section Rendering API
   (/search/suggest), so Search & Discovery synonyms, boosts and filters apply. Never loads the catalog. */
(function () {
  'use strict';
  var form = document.getElementById('navSearchPanel');
  if (!form) return;
  var input = form.querySelector('input[type="search"]');
  var box = form.querySelector('[data-ps-results]');
  var live = form.querySelector('[data-ps-live]');
  var endpoint = form.getAttribute('data-ps-url');
  if (!input || !box || !live || !endpoint || !window.fetch || !window.AbortController || !window.DOMParser) return;

  var MIN_CHARS = 2, DELAY = 250, CACHE_MAX = 20;
  var cache = {}, cacheKeys = [], timer = null, ctrl = null, reqId = 0;
  var items = [], active = -1, shownQuery = '', reported = '';

  input.setAttribute('role', 'combobox');
  input.setAttribute('aria-autocomplete', 'list');
  input.setAttribute('aria-expanded', 'false');
  input.setAttribute('aria-controls', box.id);
  input.setAttribute('autocomplete', 'off');

  function publish(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, data);
      }
    } catch (e) {}
  }
  function cleanQuery(q) {
    q = q.toLowerCase().slice(0, 60);
    return (q.indexOf('@') > -1 || /[0-9]{6,}/.test(q)) ? '[redacted]' : q;
  }
  function announce(text) {
    live.textContent = '';
    window.setTimeout(function () { live.textContent = text; }, 60);
  }
  function setActive(i) {
    if (active > -1 && items[active]) items[active].setAttribute('aria-selected', 'false');
    active = i;
    if (i > -1 && items[i]) {
      items[i].setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', items[i].id);
      if (items[i].scrollIntoView) items[i].scrollIntoView({ block: 'nearest' });
    } else {
      input.removeAttribute('aria-activedescendant');
    }
  }
  function setOpen(open) {
    box.hidden = !open;
    input.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) setActive(-1);
  }
  function seeAllHref(q) { return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q); }

  function stateBox(build) {
    var el = document.createElement('div');
    el.className = 'ps-state';
    build(el);
    box.replaceChildren(el);
    items = [];
    setActive(-1);
    setOpen(true);
  }
  function seeAllLink(q, label) {
    var a = document.createElement('a');
    a.href = seeAllHref(q);
    a.textContent = label;
    return a;
  }
  function showLoading() {
    if (box.querySelector('[data-ps-root]')) {
      box.classList.add('is-loading');
      setOpen(true);
    } else {
      stateBox(function (el) {
        var s = document.createElement('span');
        s.className = 'ps-spinner';
        s.setAttribute('aria-hidden', 'true');
        el.appendChild(s);
        el.appendChild(document.createTextNode('Searching...'));
      });
    }
    box.setAttribute('aria-busy', 'true');
  }
  function showError(q) {
    box.classList.remove('is-loading');
    box.setAttribute('aria-busy', 'false');
    stateBox(function (el) {
      el.appendChild(document.createTextNode('Live results are not available right now. Press Enter or '));
      el.appendChild(seeAllLink(q, 'search all results'));
      el.appendChild(document.createTextNode(' instead.'));
    });
    announce('Live search is unavailable. Press Enter to search all results.');
  }
  function showResults(html, q) {
    box.classList.remove('is-loading');
    box.setAttribute('aria-busy', 'false');
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var root = doc.querySelector('[data-ps-root]');
    if (!root) { showError(q); return; }
    var np = parseInt(root.getAttribute('data-ps-products'), 10) || 0;
    var nq = parseInt(root.getAttribute('data-ps-queries'), 10) || 0;
    shownQuery = q;
    if (np + nq === 0) {
      stateBox(function (el) {
        var s = document.createElement('strong');
        s.textContent = 'No results for "' + q + '"';
        el.appendChild(s);
        el.appendChild(document.createElement('br'));
        el.appendChild(document.createTextNode('Check the spelling, try a shorter word, or '));
        el.appendChild(seeAllLink(q, 'open the full search page'));
        el.appendChild(document.createTextNode('.'));
      });
      announce('No results for ' + q + '.');
    } else {
      box.replaceChildren(document.importNode(root, true));
      items = Array.prototype.slice.call(box.querySelectorAll('[data-ps-item]'));
      items.forEach(function (el, i) {
        el.id = 'ps-opt-' + i;
        el.setAttribute('role', 'option');
        el.setAttribute('aria-selected', 'false');
        el.setAttribute('data-ps-pos', String(i + 1));
      });
      setActive(-1);
      setOpen(true);
      announce(np + (np === 1 ? ' product' : ' products') + (nq ? ' and ' + nq + (nq === 1 ? ' suggestion' : ' suggestions') : '') + ' found. Use the up and down arrow keys to review.');
    }
    if (reported !== q) {
      reported = q;
      publish('predictive_search_results', { query: cleanQuery(q), product_count: np, suggestion_count: nq, no_results: np + nq === 0 });
    }
  }

  function run(q) {
    var key = q.toLowerCase();
    if (cache[key]) { showResults(cache[key], q); return; }
    if (ctrl) ctrl.abort();
    ctrl = new AbortController();
    var id = ++reqId;
    showLoading();
    var url = endpoint + '?q=' + encodeURIComponent(q) +
      '&section_id=predictive-search&resources[type]=product,query&resources[limit]=6&resources[limit_scope]=each';
    fetch(url, { signal: ctrl.signal, credentials: 'same-origin', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
      .then(function (html) {
        if (id !== reqId) return;
        if (cacheKeys.length >= CACHE_MAX) delete cache[cacheKeys.shift()];
        cache[key] = html; cacheKeys.push(key);
        showResults(html, q);
      })
      .catch(function (err) {
        if ((err && err.name === 'AbortError') || id !== reqId) return;
        showError(q);
      });
  }

  function reset() {
    window.clearTimeout(timer);
    if (ctrl) ctrl.abort();
    reqId++;
    box.classList.remove('is-loading');
    box.setAttribute('aria-busy', 'false');
    setOpen(false);
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    window.clearTimeout(timer);
    if (q.length < MIN_CHARS) { reset(); announce(''); return; }
    timer = window.setTimeout(function () { run(q); }, DELAY);
  });
  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q.length >= MIN_CHARS && q === shownQuery && box.firstChild) setOpen(true);
  });
  input.addEventListener('keydown', function (e) {
    if (box.hidden) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      if (!items.length) return;
      e.preventDefault();
      var n = items.length;
      var next = e.key === 'ArrowDown' ? (active + 1 >= n ? -1 : active + 1) : (active === -1 ? n - 1 : active - 1);
      setActive(next);
    } else if (e.key === 'Enter' && active > -1 && items[active]) {
      e.preventDefault();
      items[active].click();
    } else if (e.key === 'Escape') {
      setOpen(false); /* the existing theme.js handler then closes the panel and returns focus to the toggle */
    }
  });
  form.addEventListener('focusout', function () {
    window.setTimeout(function () { if (!form.contains(document.activeElement)) setOpen(false); }, 0);
  });
  /* the panel's outside-click close lives in theme.js; mirror it here */
  new MutationObserver(function () { if (!form.classList.contains('open')) setOpen(false); })
    .observe(form, { attributes: true, attributeFilter: ['class'] });

  box.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('[data-ps-item]') : null;
    if (!el) return;
    var type = el.getAttribute('data-ps-type');
    publish('predictive_search_result_click', {
      query: cleanQuery(shownQuery), type: type, position: parseInt(el.getAttribute('data-ps-pos'), 10) || 0,
      product_handle: el.getAttribute('data-ps-handle') || ''
    });
    if (type === 'product') {
      try { sessionStorage.setItem('mgPsAttr', JSON.stringify({ path: el.pathname, q: cleanQuery(shownQuery), t: Date.now() })); } catch (err) {}
    }
  });

  /* Search-attributed add to cart: on a product page reached from a predictive result (within 30 minutes),
     report an add when the cart count rises after the product form is submitted. */
  var attr = null;
  try { attr = JSON.parse(sessionStorage.getItem('mgPsAttr') || 'null'); } catch (err) {}
  if (attr && attr.path === location.pathname && Date.now() - attr.t < 1800000) {
    var counts = document.querySelectorAll('.cart-count');
    var pending = null;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
      var idEl = f.querySelector('[name="id"]');
      pending = { before: parseInt(counts[0] && counts[0].textContent, 10) || 0, variant: idEl ? idEl.value : '' };
    }, true);
    Array.prototype.forEach.call(counts, function (c) {
      new MutationObserver(function () {
        if (!pending) return;
        var now = parseInt(c.textContent, 10) || 0;
        if (now > pending.before) {
          publish('predictive_search_add_to_cart', {
            query: attr.q, product_handle: location.pathname.split('/').pop(), variant_id: pending.variant, quantity: now - pending.before
          });
          pending = null;
        }
      }).observe(c, { childList: true, characterData: true, subtree: true });
    });
  }
})();
